import { render } from "./CardMain.vue?vue&type=template&id=8075f32e&scoped=true"
import script from "./CardMain.vue?vue&type=script&lang=js"
export * from "./CardMain.vue?vue&type=script&lang=js"

import "./CardMain.vue?vue&type=style&index=0&id=8075f32e&scoped=true&lang=css"

import exportComponent from "/Users/siorikitajima/Dropbox (Personal)/Code/GCV/ga-emc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8075f32e"]])

export default __exports__